<template>
  <div class="class-management">
    <el-button
      class="addclass"
      size="small"
      type="primary"
      @click="singleCreateClass"
      >新建班级</el-button
    >
    <el-form
      size="small"
      :inline="true"
      class="form-style"
      ref="ruleForm"
      :model="form"
    >
      <el-form-item label="授课类型" prop="teaching_type">
        <el-select
          v-model="ruleForm.teaching_type"
          placeholder="请选择"
          style="width: 150px"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="面授课" value="1"></el-option>
          <el-option label="直播课" value="2"></el-option>
          <el-option label="录播课" value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="科目">
        <el-select
          v-model="form.subject_id"
          placeholder="请选择"
          filterable
          style="width: 150px"
          @change="getCurriculumList"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) of subjectList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="课程体系" prop="curriculum_id">
        <el-select
          v-model="form.curriculum_id"
          placeholder="请选择"
          style="width: 150px"
          :disabled="!curriculum_list.length"
        >
          <el-option
            :label="item.title"
            :value="item.id"
            v-for="(item, index) of curriculum_list"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-input
          placeholder="请输入内容"
          v-model="form.search_value"
          class="input-with-select"
        >
          <el-select
            v-model="form.search_type"
            slot="prepend"
            style="width: 110px"
          >
            <el-option label="班级名称" value="1"></el-option>
            <el-option label="班级码" value="2"></el-option>
            <el-option label="上课老师" value="3"></el-option>
          </el-select>
        </el-input>
      </el-form-item>

      <el-form-item label="开课时间：" prop="state">
        <el-date-picker
          v-model="classStartTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          placement="bottom-start"
        ></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button @click="search" type="primary">搜索</el-button>
        <el-button @click="reSize('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="setting">
      <el-checkbox-group v-model="form.course_state">
        <el-checkbox :label="1">已开课班级</el-checkbox>
        <el-checkbox :label="2">待开课班级</el-checkbox>
        <el-checkbox :label="3">已结课班级</el-checkbox>
        <el-checkbox :label="4">待排课班级</el-checkbox>
      </el-checkbox-group>
    </div>

    <div class="table-style">
      <el-table
        size="small"
        :data="tableData"
        border
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column
          width="200"
          align="center"
          prop="name"
          label="班级名称"
        ></el-table-column>

        <el-table-column align="center" width="100" label="科目">
          <template slot-scope="scope">
            {{ scope.row.subject_name }}
          </template>
        </el-table-column>

        <el-table-column width="200" align="center" label="体系名称">
          <template slot-scope="scope">
            {{ scope.row.curriculum_name }}
          </template>
        </el-table-column>

        <el-table-column width="300" label="开课/结课">
          <template slot-scope="scope">
            {{ scope.row.start_date }} /
            {{ scope.row.end_date }}
          </template>
        </el-table-column>

        <el-table-column width="200" label="授课时段">
          <template slot-scope="scope">
            {{ scope.row.week_str }} /
            {{ scope.row.time_str }}
          </template>
        </el-table-column>

        <el-table-column
          width="150"
          prop="lecturer_nickname"
          label="上课老师"
        ></el-table-column>

        <el-table-column
          width="150"
          prop="student_total_num"
          label="学员数"
        ></el-table-column>

        <el-table-column
          align="center"
          width="150"
          prop="subject_name"
          label="所属校区"
        ></el-table-column>

        <el-table-column
          align="center"
          prop="status"
          label="排课状态"
          width="100"
        ></el-table-column>

        <el-table-column align="center" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="handleDetails(scope.$index, scope.row, '1')"
              type="text"
              size="small"
              >添加学员</el-button
            >

            <el-button
              @click="GetClassStudents(scope.row)"
              type="text"
              size="small"
              >班级学员</el-button
            >

            <el-button
              type="text"
              size="small"
              @click="courseArranging(scope.row)"
              >排课/调课</el-button
            >

            <el-button type="text" size="small" @click="editClasses(scope.row)"
              >修改</el-button
            >

            <el-button
              type="text"
              size="small"
              @click="deleteClasses(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page_no"
        layout="total, prev, pager, next"
        :page-size="20"
        :total="total"
      ></el-pagination>
    </div>

    <!--正式学员管理-->
    <el-dialog width="80%" title="班级学员" :visible.sync="dialogTableVisible">
      <el-table
        :data="ClassStudentManagermentData"
        size="small"
        style="width: 100%"
      >
        <el-table-column
          width="150"
          align="center"
          prop="name"
          label="账号"
        ></el-table-column>

        <el-table-column
          width="100"
          align="center"
          prop="nickname"
          label="姓名"
        ></el-table-column>
        <el-table-column
          width="50"
          align="center"
          prop="sex"
          label="性别"
        ></el-table-column>

        <el-table-column
          width="150"
          align="center"
          prop="school_name"
          label="学校名称"
        ></el-table-column>
        <el-table-column
          width="150"
          align="center"
          prop="gradeStr"
          label="在校年级"
        ></el-table-column>

        <el-table-column align="center" label="所在班级" width="200">
          <template slot-scope="scope">
            <div v-for="item in scope.row.curriculum_class_list" :key="item.id">
              <span>{{ item.name }}</span> <br />
            </div>
          </template>
        </el-table-column>

        <el-table-column width="150" align="center" label="联系电话">
          <template slot-scope="scope">
            <span>{{ scope.row.parent_a }}</span>
            <span>{{ scope.row.parent_a_phone_num }}</span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="center" label="家长微信">
          <template slot-scope="scope">
            <span>{{ scope.row.parent_b }}</span>
            <span>{{ scope.row.parent_b_phone_num }}</span>
          </template>
        </el-table-column>

        <el-table-column width="200" fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleDetails(scope.$index, scope.row, '4')"
              >转为正式</el-button
            >

            <el-button type="text" size="mini" @click="QuitClass(scope.row)"
              >退班</el-button
            >

            <el-button
              type="text"
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              >重置密码</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!--试听学员调班-->

    <el-dialog title="学员调班" :visible.sync="dialogFormVisible">
      <el-form size="small" :model="form" label-position="left">
        <el-form-item label="学员姓名" :label-width="formLabelWidth">
          <span>史小北</span>
        </el-form-item>

        <el-form-item label="选择班级" :label-width="formLabelWidth">
          <add-class-dialog @chooseClass="chooseClass"></add-class-dialog>
          <el-table
            border
            size="small"
            :data="tableData1"
            :header-cell-style="{ background: '#f5f7fa' }"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="name"
              label="班级名称"
              width="200"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="phone"
              label="科目"
              width="50"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="phone"
              label="课程体系"
              width="150"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="subject_name"
              label="主讲老师"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="sex"
              label="授课时段"
            ></el-table-column>

            <el-table-column align="center" prop="name" label="学生数">
              6
            </el-table-column>

            <el-table-column
              align="center"
              fixed="right"
              label="操作"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="deleteRow(scope.$index, tableData)"
                  type="text"
                  size="small"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="dialogFormVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--转为正式学员--------------------------------------------->
    <el-dialog
      width="80%"
      title="转为正式学员"
      :visible.sync="dialogFormVisible1"
    >
      <el-form :model="form1" size="small">
        <el-form-item label="学员姓名" :label-width="formLabelWidth">
          <span>{{ form1.nickname }}</span>
        </el-form-item>

        <el-form-item label="选择班级" :label-width="formLabelWidth">
          <addformalClassDialog
            ref="addformalClassDialog"
            @chooseClass="chooseClass"
          ></addformalClassDialog>
        </el-form-item>

        <el-form-item
          v-show="haschoose_class"
          label="已选班级"
          :label-width="formLabelWidth"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <span>班级名称</span>

            <span style="margin-left: 10px; font-weight: 500">{{
              form1.chooseClassinfo.name
            }}</span>

            <el-button
              @click="deleteClass"
              style="margin-left: 40px"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
            ></el-button>

            <br />
            <span>体系名称</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              form1.chooseClassinfo.curriculum_name
            }}</span>

            <br />
            <span>上课老师</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              form1.chooseClassinfo.lecturer_nickname
            }}</span>
            <br />
            <span>授课时段</span>
            <span style="margin-left: 10px; font-weight: 500"
              >{{ form1.chooseClassinfo.week_str }}/{{
                form1.chooseClassinfo.time_str
              }}</span
            >
            <br />
            <span>课程价格(单位:元)</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              form1.chooseClassinfo.goods_price
            }}</span>
            <div style="width: 300px">
              <span>实收价格(单位:元)</span>
              <el-input
                size="small"
                placeholder="请输入实际交费金额"
                v-model="curriculum_class_price"
              ></el-input>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="选择商品" :label-width="formLabelWidth">
          <addGoods ref="addGoods" @chooseGoodList="chooseGoodList"></addGoods>
        </el-form-item>

        <el-form-item
          v-show="haschoose_good"
          label="已选商品"
          :label-width="formLabelWidth"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <div v-for="(item, index) of goodslist" :key="index">
              <span>商品名称</span>
              <span style="margin-left: 10px">{{ item.title }}</span>

              <el-button
                @click="deleteGoods(index)"
                style="margin-left: 40px"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                circle
              ></el-button>

              <br />
              <span>商品原价(单位:元/个)</span>
              <span style="margin-left: 10px">{{ item.present_price }}</span>
              <div style="width: 300px">
                <span>商品现价(单位:元/个)</span>
                <el-input
                  v-model="item.price"
                  size="small"
                  placeholder="请输入实际交费金额"
                ></el-input>

                <span>采购数量</span>

                <el-input-number
                  style="margin-top: 10px; margin-left: 10px"
                  size="small"
                  v-model="item.sell_out_num"
                  @change="handleChange"
                  :min="1"
                  :max="10"
                  label="描述文字"
                >
                </el-input-number>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="备注信息" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="Add_AuditionStudent">确 定</el-button>
      </div>
    </el-dialog>

    <!--公开课试听-->
    <el-dialog
      width="80%"
      title="公开课试听"
      :visible.sync="dialogFormVisible2"
    >
      <el-form :model="form1">
        <el-form-item label="学员姓名" :label-width="formLabelWidth">
          <addStudent
            ref="addStudent"
            @chooseStudent="chooseStudent"
          ></addStudent>
        </el-form-item>

        <el-form-item
          v-show="haschoose_student"
          label="已选学员"
          :label-width="formLabelWidth"
        >
          {{ chooseStudentInfo.nickname }}
        </el-form-item>

        <el-form-item
          v-show="haschoose_class"
          label="已选班级"
          :label-width="formLabelWidth"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <span>班级名称</span>

            <span style="margin-left: 10px; font-weight: 500">{{
              form1.chooseClassinfo.name
            }}</span>

            <br />
            <span>体系名称</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              form1.chooseClassinfo.curriculum_name
            }}</span>

            <br />
            <span>上课老师</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              form1.chooseClassinfo.lecturer_nickname
            }}</span>
            <br />
            <span>授课时段</span>
            <span style="margin-left: 10px; font-weight: 500"
              >{{ form1.chooseClassinfo.week_str }}/{{
                form1.chooseClassinfo.time_str
              }}</span
            >
            <br />
            <span>课程价格(单位:元)</span>
            <span style="margin-left: 10px; font-weight: 500">{{
              form1.chooseClassinfo.goods_price
            }}</span>
            <div style="width: 300px">
              <span>实收价格(单位:元)</span>
              <el-input
                size="small"
                placeholder="请输入实际交费金额"
                v-model="curriculum_class_price"
              ></el-input>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="选择商品" :label-width="formLabelWidth">
          <addGoods ref="addGoods" @chooseGoodList="chooseGoodList"></addGoods>
        </el-form-item>

        <el-form-item
          v-show="haschoose_good"
          label="已选商品"
          :label-width="formLabelWidth"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <div v-for="(item, index) of goodslist" :key="index">
              <span>商品名称</span>
              <span style="margin-left: 10px">{{ item.title }}</span>

              <el-button
                @click="deleteGoods(index)"
                style="margin-left: 40px"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                circle
              ></el-button>

              <br />
              <span>商品原价(单位:元/个)</span>
              <span style="margin-left: 10px">{{ item.present_price }}</span>
              <div style="width: 300px">
                <span>商品现价(单位:元/个)</span>
                <el-input
                  v-model="item.price"
                  size="small"
                  placeholder="请输入实际交费金额"
                ></el-input>

                <span>采购数量</span>

                <el-input-number
                  style="margin-top: 10px; margin-left: 10px"
                  size="small"
                  v-model="item.sell_out_num"
                  @change="handleChange"
                  :min="1"
                  :max="10"
                  label="描述文字"
                >
                </el-input-number>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="备注信息" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="Add_AuditionStudent"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      width="80%"
      title="订单确认"
      :visible.sync="outerVisible"
      append-to-body
    >
      <el-divider content-position="center">学员信息</el-divider>

      <div style="padding: 20px">
        <el-table
          size="small"
          :data="Audition_StudentData"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            v-show="chooseStudentInfo !== ''"
            align="center"
            prop="nickname"
            label="学员姓名"
          ></el-table-column>

          <el-table-column
            v-show="form1.nickname !== ''"
            align="center"
            prop="nickname1"
            label="学员姓名"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="subject_name"
            label="已选科目"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="classname"
            label="报名班级"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="lecturer_nickname"
            label="上课老师"
          ></el-table-column>

          <el-table-column align="center" label="授课时段" width="150">
            <template slot-scope="scope">
              {{ scope.row.week_str }} /
              {{ scope.row.time_str }}
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="start_date"
            label="开课日期"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="end_date"
            label="结课日期"
          ></el-table-column>
        </el-table>
      </div>

      <el-divider content-position="center">订单信息</el-divider>

      <div style="padding: 20px">
        <el-table
          size="small"
          :data="Audition_GoodsData"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            align="center"
            prop="title"
            label="商品名称"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="present_price"
            label="商品原价(元)"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="price"
            label="商品现价(元)"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="sell_out_num"
            label="购买数量(个)"
          ></el-table-column>

          <el-table-column align="center" label="合计(元)">
            <template slot-scope="scope">
              ¥{{
                parseFloat(scope.row.price) * parseFloat(scope.row.sell_out_num)
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="float: right; margin-right: 20px">
        <span>订单总额: </span>
        <span style="color: #ea6d03; font-size: 20px; font-weight: 500"
          >¥ {{ total_price }}</span
        >
      </div>

      <div slot="footer" style="margin-top: 20px" class="dialog-footer">
        <el-button size="small" @click="Cancel_Order">取 消</el-button>
        <el-button size="small" type="primary" @click="Submit_Order"
          >提交订单</el-button
        >
      </div>
    </el-dialog>

    <el-dialog width="80%" title="退班信息确认" :visible.sync="outerVisible1">
      <el-divider content-position="left">订单及出勤</el-divider>

      <el-row>
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <div style="padding: 20px">
              <div>
                <span style="margin-left: 20px">订单日期</span>
                <span style="margin-left: 20px">{{
                  originalOrder.created_time
                }}</span
                ><br /><br />
                <span style="margin-left: 20px">课程名称</span>
                <span style="margin-left: 20px">{{
                  originalCurriculum.title
                }}</span>
                <br /><br />
                <span style="margin-left: 20px">讲次节数</span>
                <span style="margin-left: 20px">{{
                  originalCurriculum.number_of_courses
                }}</span>
                <br /><br />
                <span style="margin-left: 20px">包含教具</span>

                <span
                  style="margin-left: 20px"
                  v-for="item in originalotherGoodsArr"
                  :key="item.id"
                >
                  {{ item.name }}<br />
                </span>

                <span style="margin-left: 20px">订单金额</span>
                <span style="margin-left: 20px"
                  >{{ originalOrder.total_amount }}元</span
                ><br /><br />

                <span style="margin-left: 20px">订单备注</span>
                <span style="margin-left: 20px">{{ originalOrder.remark }}</span
                ><br /><br />

                <span style="margin-left: 20px">签到详情</span>
                <span style="margin-left: 20px"
                  >{{ insign_num }}/{{ sign_num }} (签到次数/应签次数)</span
                >
              </div>
            </div>
          </div></el-col
        >
        <el-col :span="16"
          ><div class="grid-content bg-purple-light">
            <div style="padding: 20px">
              <el-table
                height="250"
                size="small"
                :data="originalCurriculumMeterialList"
                style="width: 100%"
                :header-cell-style="{ background: '#f5f7fa' }"
              >
                <el-table-column
                  align="center"
                  prop="title"
                  label="讲次名称"
                ></el-table-column>

                <el-table-column align="center" prop="isSign" label="是否签到">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isSign">已签到</span>
                    <span v-else>缺勤</span>
                  </template>
                </el-table-column>

                <el-table-column
                  align="center"
                  prop="classname"
                  label="签到班级"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.isSign"> 111</span>
                    <span v-else>暂无数据</span>
                  </template>
                </el-table-column>

                <el-table-column
                  align="center"
                  prop="lecturer_nickname"
                  label="签到时间"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.isSign"> 111</span>
                    <span v-else>暂无数据</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div></el-col
        >
      </el-row>

      <el-divider content-position="left">退费金额</el-divider>

      <div style="margin-top: 40px; margin-left: 10px">
        <el-form :model="form2" label-width="100px">
          <el-form-item label="课时退费">
            <el-input
              type="text"
              v-model="form2.original_curriculum_class_price"
              placeholder="请输入剩余的课时费"
              @change="OutPriceChange"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="'商品' + index"
            v-for="(item, index) in form2.otherGoodsArr"
            :key="item.id"
          >
            <div>
              <span>{{ item.title }}</span>
            </div>
            <el-input
              type="text"
              v-model="form2.otherGoodsArr[index].price"
              placeholder="请输入教具退费金额"
              @change="OutPriceChange"
            ></el-input>
          </el-form-item>

          <el-form-item label="退费方式">
            <el-select v-model="form2.refund_type" placeholder="请选择退费方式">
              <el-option label="现金" value="1"></el-option>
              <el-option label="支付宝" value="2"></el-option>
              <el-option label="微信" value="3"></el-option>
              <el-option label="银行卡" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="备注信息">
            <el-input type="textarea" v-model="form2.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div style="float: right; margin-right: 20px">
        <span>退费总额: </span>
        <span style="color: #ea6d03; font-size: 20px; font-weight: 500"
          >¥ {{ total_outprice }}</span
        >
      </div>

      <div slot="footer" style="margin-top: 20px" class="dialog-footer">
        <el-button size="small" @click="outerVisible1 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="Submit_Order"
          >确认退班</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserSubjectList } from '@/api/user'
import addClassDialog from '@/components/addClassDialog'
import addGoods from '@/components/addGoods'
import addStudent from '@/components/addStudent'
import addformalClassDialog from '@/components/addformalClassDialog'
import {
  getCurriculumList,
  getAuditionClassesList,
  deleteClasses,
  addNoClassStudentToAuditionClassForAudition,
  getStudentListByClassId, //根据班级ID获取班级学员列表
  addAuditionClassStudentToNormalClassForNormal,
  getOrderByStudentIdAndClassId,
  normalClassOrAuditionClassStudentOutClass,
} from '@/api/educational'

export default {
  name: 'open-class-management',
  components: { addClassDialog, addGoods, addStudent, addformalClassDialog },
  data() {
    return {
      tableData1: [
        {
          date: '2016-05-02',
          name: 'Python代码编程班',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333,
        },
      ],
      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,

      form: {
        search_type: '',
        search_value: '',
        subject_id: '',
        curriculum_id: '',
        teaching_type: '',
        course_state: '',
        page_no: '1',
        page_size: '20',
        class_date: [],
      },
      dialogFormVisible2: false, //公开课试听窗口
      haschoose_class: false,
      order_state: '', //学员转公开课试听

      //公开课试听学员
      form1: {
        nickname: '',
        student_user_id: '', //学生ID
        curriculum_class_id: '', //班级ID
        other_goods_list: [], //其他商品列表
        remark: '', //备注
        chooseClassinfo: {},
        chooseGoods: [],
      },
      //退费订单
      form2: {
        original_curriculum_class_price: 0,
        otherGoodsArr: [],
        refund_type: '1',
        remark: '',
      },
      Goodslist: [],
      goodslist: [],

      haschoose_student: false,
      chooseStudentInfo: {},

      outerVisible: false,
      outerVisible1: false,
      curriculum_class_price: '', //班级商品实收价格

      haschoose_good: false, //是否选择了商品

      total_price: 0,
      Audition_StudentData: [],
      Audition_GoodsData: [],

      formLabelWidth: '120px',
      ruleForm: {
        search_type: '1',
        search_value: '',
        subject_id: '',
        curriculum_id: '',
        teaching_type: '',
        class_start_time: '',
        class_end_time: '',
        is_goods: '',
        course_type: '',
        course_state: [],
      },
      classStartTime: '',
      subjectList: [],
      tableData: [],
      curriculum_list: [],
      total: 0,
      page_no: 1,

      ClassStudentManagermentData: [], //班级里的试听学员
      ClassStudentManagerment: {}, //当前选择的班级
      chooseAuditionClassList: {}, //试听班级信息

      originalCurriculumMeterialList: [], //出勤讲次
      originalCurriculum: {}, //学员报名的课程体系
      originalOrderInfo: {}, //学员退费订单详情
      originalotherGoodsArr: [],
      originalOrder: {}, //

      insign_num: 0,
      sign_num: 0,
      goodprice: 0,
    }
  },
  mounted() {
    this.getUserSubjectList()
    this.getAuditionClassesList()
  },
  methods: {
    // 获取科目
    getUserSubjectList() {
      getUserSubjectList().then((res) => {
        this.subjectList = res.base_platform.concat(res.mechanism_platform)
      })
    },
    getCurriculumList(val) {
      this.ruleForm.curriculum_id = ''
      getCurriculumList({
        subject_id: val,
        page_size: 100,
      }).then((res) => {
        this.curriculum_list = res.curriculum_list
      })
    },
    search() {
      this.getAuditionClassesList()
    },

    // 获取试听班级列表
    getAuditionClassesList() {
      getAuditionClassesList({
        search_type: this.form.search_type, //(1班级名称，2班级码，3教师姓名)
        search_value: this.form.search_value, //搜索值
        subject_id: this.form.subject_id, //科目
        curriculum_id: this.form.curriculum_id, //体系
        teaching_type: this.form.teaching_type,
        course_state: this.form.course_state, //（全部 空，1已开课班级，2待开课班级，3已结课班级，4待排课班级）
        class_start_time: this.form.class_date[0], //开课时间
        class_end_time: this.form.class_date[1], //结课时间
        page_no: this.form.page_no,
        page_size: this.form.page_size,
      }).then((res) => {
        console.log('查询所有试听班级')
        console.log(res)
        this.tableData = res.class_list
        this.total = res.class_list.length
      })
    },

    //添加公开课学员
    handleDetails(index, row, command) {
      console.log(index)
      console.log(row)
      console.log(command)
      if (command === '1') {
        this.dialogFormVisible2 = true

        this.form1.chooseClassinfo = row
        this.curriculum_class_price = row.goods_price
        this.haschoose_class = true
        this.order_state = '1' //学员转公开课试听
      } else if (command === '4') {
        console.log('班级试听学员转为正式学员')
        this.dialogFormVisible1 = true
        this.form1.nickname = row.nickname
        this.form1.student_user_id = row.id
        this.order_state = '4' //学员从试听班级转为正式学员
      }
    },

    //试听学员转为正式学员
    addAuditionClassStudentToNormalClassForNormal() {
      addAuditionClassStudentToNormalClassForNormal({
        student_user_id: this.form1.student_user_id,
        curriculum_class_id: this.form1.chooseClassinfo.id,
        curriculum_class_price: this.curriculum_class_price,
        other_goods_list: JSON.stringify(this.goodslist),
        audition_curriculum_class_id: this.chooseAuditionClassList.id,
      }).then((res) => {
        console.log('班级试听学员转为正式学员')
        console.log(res)
        if (res.is_create) {
          this.dialogFormVisible1 = false
          this.outerVisible = false
          this.$message.success('成功生成订单')
          // this.getNoClassStudentList();
          this.$router.push({ name: 'listen-test-management' })
        }
      })
    },

    QuitClass(row) {
      console.log('试听学员退班')
      console.log(row)
      this.form1.student_user_id = row.id
      console.log('退班参数')
      console.log(this.form1.student_user_id)
      console.log(this.chooseAuditionClassList.id)

      this.outerVisible1 = true
      this.order_state = '6'

      this.getOrderByStudentIdAndClassId()
    },

    Cancel_Order() {
      console.log('取消订单')
      this.total_price = 0
      this.outerVisible = false
    },

    Submit_Order() {
      console.log('提交订单')

      console.log('学生ID-1')
      console.log(this.chooseStudentInfo.id)
      console.log('学生ID-2')
      console.log(this.form1.student_user_id)

      console.log('班级ID')
      console.log(this.form1.chooseClassinfo.id)
      console.log('班级商品价格')
      console.log(this.curriculum_class_price)
      console.log('其他商品列表')
      console.log(this.goodslist)

      if (this.order_state === '1') {
        console.log('有账号学员转为试听订单')
        this.addNoClassStudentToAuditionClassForAudition()
      } else if (this.order_state === '4') {
        console.log('学员从试听班级报名正式学员')
        this.addAuditionClassStudentToNormalClassForNormal()
      } else if (this.order_state === '6') {
        console.log('学员退班')
        console.log(this.form2)
        this.normalClassOrAuditionClassStudentOutClass()
      }
    },

    //有账号学员进试听班级
    addNoClassStudentToAuditionClassForAudition() {
      addNoClassStudentToAuditionClassForAudition({
        student_user_id: this.chooseStudentInfo.id,
        curriculum_class_id: this.form1.chooseClassinfo.id,
        curriculum_class_price: this.curriculum_class_price,
        other_goods_list: JSON.stringify(this.goodslist),
      }).then((res) => {
        console.log('有账号学员转为试听学员')
        console.log(res)
        if (res.is_create) {
          this.dialogFormVisible2 = false
          this.outerVisible = false
          this.$message.success('成功生成订单')
          this.getNoClassStudentList()
          this.$router.push({ name: 'open-class-management' })
        }
      })
    },

    chooseClass(val) {
      console.log('子组件传值')
      console.log(val)
      this.form1.chooseClassinfo = val
      this.haschoose_class = true
    },

    chooseStudent(val) {
      console.log('子组件传值-已选学员')
      console.log(val)

      this.haschoose_student = true
      this.chooseStudentInfo = val
    },

    handleCurrentChange(val) {
      this.page_no = val
    },
    reSize(formName) {
      this.$refs[formName].resetFields()
    },
    deleteClasses(row) {
      this.$confirm('确定删除当前班级?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteClasses({
          class_code: row.class_code,
        }).then(() => {
          this.$message.success('删除成功')
        })
      })
    },
    lookClasses(row) {
      this.$router.push({
        name: 'look-class-info',
        query: {
          class_code: row.class_code,
        },
      })
    },
    courseArranging(row) {
      this.$router.push({
        name: 'open-course-arranging',
        query: {
          class_code: row.class_code,
          id: row.id,
        },
      })
    },
    editClasses(row) {
      this.$router.push({
        name: 'create-class',
        query: {
          class_code: row.class_code,
        },
      })
    },

    //数组对象去重
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },

    chooseGoodList(val) {
      console.log('子组件传值-已选商品')
      console.log(val)
      for (var i = 0; i < val.length; i++) {
        this.Goodslist = [...new Set([...this.Goodslist, val[i]])]
      }
      //商品列表
      this.Goodslist = this.unique(this.Goodslist)
      this.Goodslist.forEach((item, index) => {
        console.log(index)
        const goods = {
          id: item.id,
          title: item.name,
          price: item.present_price,
          sell_out_num: 1,
        }
        //价格
        this.goodslist.push(goods)
      })

      this.goodslist = this.unique(this.goodslist)
      console.log('this.goodslist')
      console.log(this.goodslist)
      this.haschoose_good = true
    },

    deleteGoods(index) {
      console.log('删除商品')
      console.log(index)
      //删除起始下标为1，长度为1的一个值(len设置1，如果为0，则数组不变)
      var goodlist = this.goodslist
      goodlist.splice(index, 1)
      this.goodslist = goodlist
      if (goodlist.length < 1) {
        this.haschoose_good = false
        this.goodslist = []
        this.Goodslist = []
      }
    },
    Add_AuditionStudent() {
      console.log('添加试听学员')
      console.log(this.form1)
      console.log(this.curriculum_class_price)
      console.log(this.goodslist)

      this.Audition_StudentData = [
        {
          nickname: this.chooseStudentInfo.nickname,
          nickname1: this.form1.nickname,
          classname: this.form1.chooseClassinfo.name,
          week_str: this.form1.chooseClassinfo.week_str,
          time_str: this.form1.chooseClassinfo.time_str,
          subject_name: this.form1.chooseClassinfo.subject_name,
          curriculum_name: this.form1.chooseClassinfo.curriculum_name,
          lecturer_nickname: this.form1.chooseClassinfo.lecturer_nickname,
          start_date: this.form1.chooseClassinfo.start_date,
          end_date: this.form1.chooseClassinfo.end_date,
        },
      ]

      this.Audition_GoodsData = [
        {
          title: this.form1.chooseClassinfo.curriculum_name,
          present_price: this.form1.chooseClassinfo.goods_price,
          price: this.curriculum_class_price,
          sell_out_num: '1',
        },
      ]

      for (var i = 0; i < this.goodslist.length; i++) {
        this.Audition_GoodsData = [
          ...new Set([...this.Audition_GoodsData, this.goodslist[i]]),
        ]
      }

      //计算总金额
      for (var j = 0; j < this.Audition_GoodsData.length; j++) {
        console.log('计算总金额')
        console.log(this.Audition_GoodsData)
        this.total_price =
          this.total_price +
          parseFloat(this.Audition_GoodsData[j].price) *
            parseFloat(this.Audition_GoodsData[j].sell_out_num)
      }

      console.log('总金额:' + this.total_price)
      this.outerVisible = true
    },

    // 单个建班
    singleCreateClass() {
      this.$router.push({
        name: 'create-openclass',
      })
    },

    //班级学员管理

    GetClassStudents(row) {
      console.log('选择了班级')
      console.log(row)
      this.dialogTableVisible = true
      this.chooseAuditionClassList = row

      getStudentListByClassId({
        classId: row.id,
        state: '2', //1正式 2试听
      }).then((res) => {
        console.log('根据班级ID获取学员列表')
        console.log(res)

        this.ClassStudentManagermentData = res.student_list //班级里的试听学员
        this.ClassStudentManagerment = row
      })
    },

    //退班-查询退班订单
    getOrderByStudentIdAndClassId() {
      console.log('退班参数')
      console.log(this.form1.student_user_id)
      console.log(this.chooseAuditionClassList.id)

      getOrderByStudentIdAndClassId({
        student_user_id: this.form1.student_user_id,
        original_curriculum_class_id: this.chooseAuditionClassList.id,
      }).then((res) => {
        console.log('查询退班学员订单')
        console.log(res)

        this.originalCurriculumMeterialList = res.originalCurriculumMeterialList

        this.sign_num = res.originalCurriculumMeterialList.length

        this.originalCurriculum = res.originalCurriculum
        this.originalotherGoodsArr = res.otherGoodsArr

        //记录退费商品信息
        this.originalotherGoodsArr.forEach((item, index) => {
          console.log(index)
          const goods = {
            id: item.id,
            title: item.name,
            price: 0,
          }
          //价格
          this.form2.otherGoodsArr.push(goods)
        })

        //记录出勤信息
        this.originalCurriculumMeterialList.forEach((item, index) => {
          console.log(index)

          if (item.isSign) {
            this.insign_num = +1
          }
        })

        console.log('退费商品信息')
        console.log(this.form2.otherGoodsArr)
        this.originalOrder = res.order
      })
    },

    OutPriceChange() {
      console.log('退费金额发生变化')
      console.log(this.form2)

      //记录退费商品信息
      this.form2.otherGoodsArr.forEach((item, index) => {
        console.log(index)
        this.goodprice = +parseFloat(item.price)
      })

      this.total_outprice =
        parseFloat(this.form2.original_curriculum_class_price) +
        parseFloat(this.goodprice)
    },

    //退班-查询退班订单
    normalClassOrAuditionClassStudentOutClass() {
      console.log('退班参数')
      console.log(this.form1.student_user_id)
      console.log(this.chooseAuditionClassList.id)
      console.log(this.form2.original_curriculum_class_price)
      console.log(this.form2.refund_type)
      console.log(this.form2.remark)
      console.log(this.otherRefundOrderGoodsList)

      normalClassOrAuditionClassStudentOutClass({
        student_user_id: this.form1.student_user_id,
        original_curriculum_class_id: this.chooseAuditionClassList.id,
        original_curriculum_class_price: this.form2
          .original_curriculum_class_price,
        refund_type: this.form2.refund_type,
        otherRefundOrderGoodsList: this.form2.otherGoodsArr,
        remark: this.form2.remark,
      }).then((res) => {
        console.log('正式学员退班')
        console.log(res)
        if (res.is_update) {
          this.outerVisible1 = false
          this.$message.success('退班成功')
          this.$router.push({ name: 'open-class-management' })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.class-management {
  height: 100%;
  padding: 15px;
  margin: 15px;
  border-radius: 5px;
  box-sizing: border-box;
  background-color: #fff;

  .setting {
    float: right;
  }
  .table-style {
    margin-top: 40px;
  }
}
</style>
